import React from 'react';
import PropTypes from 'prop-types';
import { DeliveryOptions } from '@thd-olt-component-react/delivery-options';
import { getDeliveryOptionsText,
  showTodayOrTomorrow } from '../../../helper/utils';
import { DeliveryDetails } from './DeliveryDetails';

const ExpressDeliveryZipCode = ({ zipCode }) => {
  return (
    <>
      <span>to&nbsp;</span>
      <span className="sui-font-bold">{zipCode}</span>
    </>
  );
};

ExpressDeliveryZipCode.propTypes = {
  zipCode: PropTypes.string
};

ExpressDeliveryZipCode.defaultProps = {
  zipCode: null
};

const ExpressDeliveryDetails = ({
  itemId,
  storeId,
  quantity,
  zipCode,
  locations,
  shippingData,
  maxInventoryAvail,
  disableSTH,
  isCartTiles = false,
  fallbackMode = false,
  isSpecialOrder = false,
  isConfigurableBlinds = false,
  originalConfigId = null
}) => {
  const deliveryOptionsText = getDeliveryOptionsText(shippingData);

  if (isCartTiles || isConfigurableBlinds || isSpecialOrder) {
    return null;
  }

  return (
    <>
      <DeliveryDetails
        itemId={itemId}
        storeId={storeId}
        zipCode={zipCode}
        quantity={quantity}
        shippingData={shippingData}
        isCartTiles={isCartTiles}
        fallbackMode={fallbackMode}
        originalConfigId={originalConfigId}
      />
    </>
  );
};

ExpressDeliveryDetails.propTypes = {
  itemId: PropTypes.string.isRequired,
  storeId: PropTypes.string,
  quantity: PropTypes.number,
  zipCode: PropTypes.string,
  locations: PropTypes.arrayOf(PropTypes.shape({
    isAnchor: PropTypes.bool,
    inventory: PropTypes.shape({
      quantity: PropTypes.number,
      isInStock: PropTypes.bool,
      isLimitedQuantity: PropTypes.bool,
      isBackordered: PropTypes.bool
    })
  })),
  // eslint-disable-next-line react/forbid-prop-types
  shippingData: PropTypes.objectOf(PropTypes.any),
  maxInventoryAvail: PropTypes.number,
  isCartTiles: PropTypes.bool,
  fallbackMode: PropTypes.bool,
  isSpecialOrder: PropTypes.bool,
  isConfigurableBlinds: PropTypes.bool,
  disableSTH: PropTypes.bool,
  originalConfigId: PropTypes.string,
};

ExpressDeliveryDetails.defaultProps = {
  storeId: null,
  quantity: 1,
  zipCode: null,
  locations: [{
    isAnchor: false,
    inventory: {
      quantity: null,
      isInStock: false,
      isLimitedQuantity: null,
      isBackordered: false
    }
  }],
  shippingData: {},
  maxInventoryAvail: 0,
  isCartTiles: false,
  fallbackMode: false,
  isSpecialOrder: false,
  isConfigurableBlinds: false,
  disableSTH: false,
  originalConfigId: null,
};

export { ExpressDeliveryDetails };
